import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { QUOTEMEDIA_EOD_PRICE_TASK_BASE_PATH } from '../../../../../../../../../features/vendor/quotemedia/eod-price/task/quotemedia-eod-price-task-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/task/_task')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'quote-media-eod-price-task-list',
        label: 'QuoteMedia',
        to: QUOTEMEDIA_EOD_PRICE_TASK_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
